









import { Component, Vue, Mixins, Prop } from 'vue-property-decorator'
import Visualization from '../../mixins/Visualization.vue'
import Canvas from '../../mixins/Canvas.vue'
import Grid from '../../mixins/Grid.vue'
import WrappedText from '../../mixins/WrappedText.vue'
import { Options } from '../../@types/Slide'
import { ChartDataSets } from 'chart.js'

@Component
export default class SunFlower extends Mixins(Canvas, Grid, WrappedText) {
  private interval: any = null

  private tick: number = 0

  /**
   * Default options.
   */
  public readonly defaultChartOptions: Options = {
    duration: 3000 / 60
  }

  /**
   * Default dataset options.
   */
  public readonly defaultDatasetOptions: ChartDataSets = {
    backgroundColor: ['gray-800']
  }

  /**
   * Get radius.
   */
  get radius() {
    const { width } = this.datasetsGrid[0]
    return ((width / 4) * this.tick) / this.__options.duration
  }

  /**
   * Draw circles/
   */
  public drawCircle(grid: any) {
    this.context.save()
    this.context.strokeStyle = 'gray-800'
    this.context.beginPath()
    this.context.arc(grid.x, grid.y, this.radius, 0, 2 * Math.PI)
    this.context.lineWidth = 5
    this.context.stroke()
    this.context.restore()
  }

  /**
   * Draw title.
   */
  public drawTitle(grid: any) {
    this.context.save()
    this.context.textAlign = 'center'
    this.wrapText(
      this.context,
      grid.label,
      grid.x,
      grid.y,
      this.radius,
      `${(2 / this.__options.duration) * this.tick}rem`
    )
    this.context.restore()
  }

  /**
   * Get value for equal, inferior, superior.
   */
  private padding(nb1: number, nb2: number, [value1, value2, value3]) {
    return nb1 === nb2 ? value1 : nb1 < nb2 ? value2 : value3
  }

  /**
   * Get angle.
   */
  private getAngle(grid: any, index: number) {
    const angle = (((360 / grid.data.length) * index + 45) * Math.PI) / 180
    return (angle / this.__options.duration) * this.tick
  }

  /**
   * Draw labels.
   */
  public drawLabel(grid: any, text: string, index: number) {
    const angle = this.getAngle(grid, index)
    const toX = grid.x + this.radius * 1.5 * Math.cos(angle)
    const toY = grid.y + this.radius * 1.5 * Math.sin(angle)
    const startX = grid.x + this.radius * Math.cos(angle)
    const startY = grid.y + this.radius * Math.sin(angle)
    const color = Array.isArray(grid.data.backgroundColor)
      ? grid.data.backgroundColor[grid.data.indexOf(text)]
      : this.__options.backgroundColor
    this.context.save()
    this.context.fillStyle = color
    this.context.moveTo(startX, startY)
    this.context.lineWidth = 5
    this.context.lineTo(toX, toY)
    this.context.stroke()
    this.context.strokeStyle = color
    this.context.textAlign = this.padding(toX, grid.x, [
      'center',
      'end',
      'start'
    ])
    this.context.textBaseline = this.padding(toY, grid.y, [
      'middle',
      'bottom',
      'top'
    ])

    this.wrapText(
      this.context,
      text,
      toX + this.padding(toX, grid.x, [0, -5, 5]),
      toY + this.padding(toY, grid.y, [0, -5, 5]),
      100,
      `${(1.5 / this.__options.duration) * this.tick}rem`
    )
    this.context.restore()
  }

  /**
   * Render the canvas.
   */
  public renderCanvas() {
    this.reset()

    this.datasetsGrid.forEach(grid => {
      this.drawCircle(grid)
      this.drawTitle(grid)
      grid.data.forEach((data, index) => this.drawLabel(grid, data, index))
    })

    this.tick++

    if (this.tick < this.__options.duration) {
      requestAnimationFrame(this.renderCanvas)
    }
  }

  /**
   *
   */
  mounted() {
    window.addEventListener('resize', () => (this.tick = 0))
  }
}
